module.exports = __webpack_public_path__ + "static/media/linkedin_icon.84c69532.svg";